/* eslint-disable */
import axios from "axios";
import store from "../../store";
import customModal from "../customModal/customModal.vue";

export default {

    name: "AeExportModal",

    components: {
        customModal
    },

    props: {

        studyId: {
            type: String,
            required: true
        }
    },

    data() {

        return {

            baseapi: process.env.VUE_APP_Service_URL,

            selectedExportType: "",

            formErrors: {},

            loader: false
        };
    },

    methods: {

        async submitExport() {

            this.formErrors = {};

            if (!this.selectedExportType) {

                this.formErrors.selectedExportType =
                    "Export type is required";

                return;
            }

            const token = store.getters.getIdToken;

            this.loader = true;

            try {

                const payload = {
                    studyId: store.getters.getStudyIs,
                    dataType: this.selectedExportType
                };

                // required only for XML
                if (this.selectedExportType === "E2B_SAE") {

                    payload.fileName = "E2B_SAE";
                }

                const response = await axios.post(
                    `${this.baseapi}/forms/saexml/saeexport`,
                    payload,
                    {
                        headers: {
                            Authorization: "Bearer " + token,
                            "Content-Type": "application/json"
                        },
                        responseType: "blob"
                    }
                );

                // backend content type
                const contentType =
                    response.headers["content-type"];

                console.log("CONTENT TYPE:", contentType);

                // handle API errors
                if (
                    contentType.includes("application/json") ||
                    contentType.includes("text/plain")
                ) {

                    const errorText =
                        await response.data.text();

                    console.error(errorText);

                    alert(errorText);

                    return;
                }

                // get filename from backend
                let fileName = "exported_file";

                const disposition =
                    response.headers["content-disposition"];

                if (disposition) {

                    const utf8Match =
                        disposition.match(/filename\*=UTF-8''([^;]+)/);

                    if (utf8Match && utf8Match[1]) {

                        fileName =
                            decodeURIComponent(utf8Match[1]);

                    } else {

                        const asciiMatch =
                            disposition.match(/filename="?([^"]+)"?/);

                        if (asciiMatch && asciiMatch[1]) {

                            fileName = asciiMatch[1];
                        }
                    }
                }

                // download
                const blob = new Blob(
                    [response.data],
                    { type: contentType }
                );

                const url =
                    window.URL.createObjectURL(blob);

                const link =
                    document.createElement("a");

                link.href = url;

                link.setAttribute(
                    "download",
                    fileName
                );

                document.body.appendChild(link);

                link.click();

                link.remove();

                window.URL.revokeObjectURL(url);

                this.closeModal();

            } catch (error) {

                console.error(
                    "Export API Error",
                    error
                );

                alert("Failed to export file");

            } finally {

                this.loader = false;
            }
        },

        closeModal() {

            this.$emit("closeModal");
        }
    }
};